module.exports = __webpack_public_path__ + "static/img/connect_img_append_1.acb4ce78.png";